const actions = {
    GET_INSUMOS_REQUEST: 'GET_INSUMOS_REQUEST',
    CREATE_INSUMO_REQUEST: 'CREATE_INSUMO_REQUEST',
    EDIT_INSUMO_REQUEST: 'EDIT_INSUMO_REQUEST',
    DELETE_INSUMO_REQUEST: 'DELETE_INSUMO_REQUEST',

    GET_INSUMOS_SUCCESS: 'GET_INSUMOS_SUCCESS',
    CREATE_INSUMO_SUCCESS: 'CREATE_INSUMO_SUCCESS',
    EDIT_INSUMO_SUCCESS: 'EDIT_INSUMO_SUCCESS',
    DELETE_INSUMO_SUCCESS: 'DELETE_INSUMO_SUCCESS',

    SET_CURRENT_INSUMO: 'SET_CURRENT_INSUMO',
    CLEAR_CURRENT_INSUMO: 'CLEAR_CURRENT_INSUMO',

    SET_CURRENT_PROCESO: 'SET_CURRENT_PROCESO',
    CLEAR_CURRENT_PROCESO: 'CLEAR_CURRENT_PROCESO',

    GET_INVENTARIO: 'GET_INVENTARIO',

    SET_REGISTRO_INVENTARIO: 'SET_REGISTRO_INVENTARIO',
    GET_REGISTRO_INVENTARIO: 'GET_REGISTRO_INVENTARIO',
    GET_REGISTRO_SUCCESS: 'GET_REGISTRO_SUCCESS',

    initDataIsumos: (query) => ({ type: actions.GET_INSUMOS_REQUEST, query }),
    createInsumo: data => ({
        type: actions.CREATE_INSUMO_REQUEST,
        payload: data
    }),
    editInsumo: data => ({
        type: actions.EDIT_INSUMO_REQUEST,
        payload: data
    }),
    deleteInsumo: id => ({
        type: actions.DELETE_INSUMO_REQUEST,
        payload: id
    }),
    setCurrentInsumo: data => ({
        type: actions.SET_CURRENT_INSUMO,
        payload: data
    }),
    clearCurrentInsumo: () => ({
        type: actions.CLEAR_CURRENT_INSUMO,
    }),
    setCurrentProceso: data => ({
        type: actions.SET_CURRENT_INSUMO,
        payload: data
    }),
    clearCurrentProceso: () => ({
        type: actions.CLEAR_CURRENT_INSUMO,
    }),
    getInventario: () => ({
        type: actions.GET_INVENTARIO,
    }),
    registroInventario: data => ({
        type: actions.SET_REGISTRO_INVENTARIO,
        payload: data
    }),
    getRegistroInventario: () => ({
        type: actions.GET_REGISTRO_INVENTARIO
    }),

};
export default actions;